import { FormikValues, useFormikContext } from 'formik';
import React from 'react';

interface Props {
    children: React.ReactElement | React.ReactElement[] | string;
    tema?: 'primary' | 'secondary' | 'light' | 'dark' | 'success' | 'danger' | 'warning' | 'info';
    type?: 'submit' | 'reset' | 'button';
}

const Botao = ({ children, tema = 'primary', type = 'submit' }: Props): React.ReactElement =>
{
    const { isSubmitting, } = useFormikContext<FormikValues>();

    return (
        <button
            type={ type }
            className={ `btn btn-${tema}` }
            disabled={ isSubmitting }
        >
            <span className={ `${isSubmitting && type === 'submit' ? 'visually-hidden' : ''}` }>
                { children }
            </span>
            { isSubmitting && type === 'submit' && (
                <React.Fragment>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    Aguarde...
                </React.Fragment>
            ) }
        </button>
    );
}

export default Botao;
